import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import useStyles from './styles/RatePlansPoliciesListTableHead.styles'

interface RatePlansPoliciesListTableHeadMobileProps {
  reloadData: () => void
}
const RatePlansPoliciesListTableHeadMobile: React.FC<
  RatePlansPoliciesListTableHeadMobileProps
> = ({ reloadData }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body1">{getTranslate('Name')}</Typography>
      </div>
      <div>
        <IconButton onClick={() => reloadData()}>
          <RefreshIcon />
        </IconButton>
      </div>
    </div>
  )
}
export default RatePlansPoliciesListTableHeadMobile
